// extracted by mini-css-extract-plugin
export default {"isaacLoading":"IsaacLoading_isaacLoading__ZlzFb"};